import React from "react";
import ReactDOMClient from "react-dom/client";
import { App } from "./App";

// Aplica el zoom al cargar la aplicación
const applyZoom = (zoomLevel) => {
    document.body.style.transform = `scale(${zoomLevel})`;
    document.body.style.transformOrigin = "top center";
};

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);

// Aplica el zoom al cuerpo del documento antes de renderizar la aplicación
applyZoom(0.75);

root.render(<App />);
